export const WEEKDAYS = ["M", "T", "W", "T", "F", "S", "S"];

export const buildCalendarDays = (monthDate) => {
  const year = monthDate.getFullYear();
  const month = monthDate.getMonth();
  const firstWeekday = (new Date(year, month, 1).getDay() + 6) % 7; // Monday-start
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const daysInPrevMonth = new Date(year, month, 0).getDate();

  const today = new Date();
  const isToday = (day) =>
    today.getFullYear() === year && today.getMonth() === month && today.getDate() === day;

  const cells = [];
  for (let i = firstWeekday - 1; i >= 0; i--) {
    cells.push({ key: `prev-${i}`, n: daysInPrevMonth - i, dim: true });
  }
  for (let day = 1; day <= daysInMonth; day++) {
    cells.push({ key: `cur-${day}`, n: day, today: isToday(day) });
  }
  let nextDay = 1;
  while (cells.length % 7 !== 0) {
    cells.push({ key: `next-${nextDay}`, n: nextDay, dim: true });
    nextDay++;
  }
  return cells;
};

export const formatCallDuration = (seconds) => {
  const total = Math.round(Number(seconds) || 0);
  const mins = Math.floor(total / 60);
  const secs = total % 60;
  return `${mins}:${String(secs).padStart(2, "0")}`;
};

export const callStatusLabel = (status) => {
  if (status === "ANSWERED") return "Answered";
  if (status === "CANCEL") return "Cancelled";
  return status || "Missed";
};

export const formatFollowUpDate = (dateStr) => {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return { label: dateStr, tone: "" };

  const startOfDay = (dt) => new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
  const diffDays = Math.round((startOfDay(d) - startOfDay(new Date())) / 86400000);
  const time = d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
  const shortDate = d.toLocaleDateString("en-GB", { day: "numeric", month: "short" });

  if (diffDays === 0) return { label: `Today, ${time}`, tone: "today" };
  if (diffDays === -1) return { label: `Yesterday, ${time}`, tone: "overdue" };
  if (diffDays === 1) return { label: `Tomorrow, ${time}`, tone: "upcoming" };
  return { label: `${shortDate}, ${time}`, tone: diffDays < 0 ? "overdue" : "upcoming" };
};

export const initialsOf = (name) =>
  name
    ? name
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((w) => w[0]?.toUpperCase())
        .join("")
    : "";

export const STATUS_COLOR_VARS = {
  available: "var(--green)",
  unavailable: "var(--red)",
  break: "var(--orange)",
};

export const STATUS_LABELS = {
  available: "Available",
  unavailable: "Unavailable",
  break: "On Break",
};
